export const tooltip = 998;
export const dropdown = 999;
export const modal = 1001;
export const modalBackdrop = 1000;
export const customBox = 30;
//# sourceMappingURL=zIndex.js.map